import { Lineup, LineupRubric } from './store/types'
import { LineupApiResponse } from '../preContest/queries/queryTypes'

export const isLineupComplete = (lineup: Lineup) =>
  !lineup.players.some((p: LineupRubric) => p.name === '')

// Favorites persist a frozen copy of the lineup in localStorage
// (lineupbuilder-favorites-<slateId>), which Entry Manager reads at upload
// time — so this snapshot must be rebuilt whenever a favorited lineup is
// edited, not only when the heart is first clicked.
export const convertLineupToApiResponse = (lineup: Lineup): LineupApiResponse => {
  const exportableLineup = lineup.players
    .filter((p: LineupRubric) => p.nameAndId !== '')
    .map((p: LineupRubric) => p.nameAndId)
    .join(',');

  return {
    id: lineup.id,
    exportableLineup: exportableLineup,
    exportableNameAndId: exportableLineup,
    fantasyPoints: lineup.players.reduce((acc: number, player: LineupRubric) => acc + player.fpp, 0),
    lineupRoi: parseFloat(lineup.simResults?.simRoi || '0'),
    ownershipSum: lineup.players.reduce((acc: number, player: LineupRubric) => acc + (player.ownership * 100), 0),
    totalLineups: 1,
    dupesPerLineup: 1,
    averageFantasyPoints: lineup.players.reduce((acc: number, player: LineupRubric) => acc + player.fpp, 0),
    averageOwnershipSum: lineup.players.reduce((acc: number, player: LineupRubric) => acc + (player.ownership * 100), 0),
    averageLineupRoi: parseFloat(lineup.simResults?.simRoi || '0'),
  } as LineupApiResponse;
};
